import React from "react";
import { useState, useRef } from "react";
import { useParams } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

import TextField from "@base/Inputs/Text";
import Toast from "@base/Toast";
import Title from "@base/Title";
import Subtitle from "@base/Subtitle";

import { ProcessoResolver } from "@helpers/ProcessoHelper";

import Cartao from "@pages/Escola/Cartoes/componentes/Cartao";

import EscolaService from "@services/EscolaService";

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color: "#333",
				fontSize: 24,
			}
		}
	)
);

export const DigitarCartao = (props) => {

	const [cartaoInformado, setCartaoInformado] = useState("");
	const [, setInepInformado] = useState("");
	const params = useParams();
	const processo = ProcessoResolver(params.processo);
	const pageName = `Digitação de Cartões`;
	const inputEl = useRef(null);
	const toastRef = useRef(null);
	const [cartoes, setCartoes] = useState([]);

	const informarCartao = (evt) => {
		setCartoes([]);
		
		if(evt.target.value.length <= 16) {
			setCartaoInformado(evt.target.value);
			setInepInformado(evt.target.value.substring(2, 10));
		}

		if(evt.target.value.length === 16) {
			EscolaService.buscarCartaoPeloCodigo(processo.id, evt.target.value)
				.then(resultado => {
					if(resultado.status === 200) {
						let cartoes = resultado.data;
						carregaCartao(cartoes);
					} else {
						toastRef.current.show("warning", "Código de Cartão não encontrado!");
					}
				}).catch(e => {
					toastRef.current.show("error", "Houve um problema ao tentar buscar o Cartão.");
				});
			} else {
				setCartoes([]);
			}
	};

	const carregaCartao = (cartoes) => {
		Promise.allSettled(cartoes.map(c => EscolaService.downloadArquivoCartao(processo.id, c.escola, c.id)))
			.then(results => {
				results.forEach((result, index) => {
					if(result.status !== 'rejected') cartoes[index].blob = result.value.data;

					if(result.status === 'rejected') {
						if(cartoes.length === 1) toastRef.current.show("error", "Não foi possível efetuar download do arquivo.");
						if(cartoes.length > 1) toastRef.current.show("error", "Não foi possível efetuar o download do arquivo de um dos cartões.");
					}
				});
			}, cartoes).finally(() => {
					setCartoes(cartoes);
			});
	}

	const reset = () => {

		if(cartoes.length > 1) {
			setCartoes(cartoes);
		} else {
			setCartaoInformado("");
			setCartoes([]);
			inputEl.current.focus();
		}

		toastRef.current.show("success", "Cartão digitado com sucesso!");
	};

	return (
		<>
			<Toast ref={toastRef} />

			<Title>{pageName}</Title><br />

			<Grid container spacing={2}>
				<Grid item sm={12}>
					<Paper className={useStyles().wrapper} elevation={0}>
						<Subtitle>
							Informe o Código do Cartão
						</Subtitle>

						<Grid alignItems="center" container spacing={1}>
							<Grid item sm={6}>
								<TextField
									inputRef={inputEl}
									inputProps={{ maxLength: 16 }}
									autoFocus
									label="Código"
									value={cartaoInformado}
									onChange={informarCartao} />
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item sm={12}>
					{cartoes ?

						cartoes.map(c => {
							return (
								<>
									<Grid container sm={12} lg={12}>
										<Grid item sm={12} lg={12}>
											<Cartao
												processo={processo.id}
												escola={c.escola}
												codigo={c.codigo}
												origem={c.origem.id}
												id={c.id}
												onUpdate={reset}
												cartao={c} />
										</Grid>
									</Grid>
									<br/>
								</>
							)
						}
						) : <></>}
				</Grid>
			</Grid>
		</>
	);
}

export default DigitarCartao;
